import { HttpErrorResponse } from '@angular/common/http'

export let httpErrorParser = {
  respErrorMessage(error: Error) {
    if (error instanceof HttpErrorResponse) {
      let err = error.error?.error
      if (err) {
        return err
      }
      let msg = error.error?.message
      if (msg) {
        return msg
      }
      let errors = error.error?.errors
      if (errors) {
        if (errors?.new_password) {
          return errors?.new_password[0]
        }
      }
    }
    return error.message
  }
}
